import { render, staticRenderFns } from "./ProductBadge.vue?vue&type=template&id=199ce7be&scoped=true"
import script from "./ProductBadge.vue?vue&type=script&lang=ts"
export * from "./ProductBadge.vue?vue&type=script&lang=ts"
import style0 from "./ProductBadge.vue?vue&type=style&index=0&id=199ce7be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "199ce7be",
  null
  
)

export default component.exports